module.exports = __webpack_public_path__ + "static/media/fuelShortage_120.84e1e478.png";